module.exports = __webpack_public_path__ + "static/media/glass.db92d709.dae";